import { render, staticRenderFns } from "./MobHomeFlow.vue?vue&type=template&id=6a198dcb&scoped=true"
import script from "./MobHomeFlow.vue?vue&type=script&setup=true&lang=js"
export * from "./MobHomeFlow.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobHomeFlow.vue?vue&type=style&index=0&id=6a198dcb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a198dcb",
  null
  
)

export default component.exports